import styled from "styled-components";
import { motion } from "framer-motion";
import { v, b } from "../../styles/variables";

export const ProjectBox = styled(motion.div)`
	max-width: 400px;
	background: ${({ theme }) => theme.bg};
	box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
	border-radius: 5px;
	padding: ${v.smallDist};
	justify-self: center;
	display: flex;
	flex-direction: column;

	button {
		padding: 0.5rem ${v.smallDist};
	}

	> div {
		flex: 1;
	}

	.img__container {
		margin-bottom: ${v.smallDist};

		img {
			height: 100%;
		}
	}

	.project-name {
		flex-basis: 30%;
		margin-bottom: ${v.smallDist};
	}

	.btn__container {
		text-align: center;
	}
`;

export const ProjectDetails = styled(motion.div)`
	position: fixed;
	transform-origin: top;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	overflow-y: scroll;
	background: ${({ theme }) => theme.shadow};
	z-index: 99;
	padding: ${v.smallDist};

	button {
		padding: 0.5rem ${v.smallDist};
	}

	@media ${b.medium} {
		padding: ${v.mediumDist};
	}

	@media ${b.large} {
		padding: ${v.mediumDist} calc(${v.xxLargeDist} * 3);
	}

	.project-detail {
		background: ${({ theme }) => theme.bg};
		box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
		transform-origin: top;
		border-radius: 5px;
		min-height: 100vh;
		padding: ${v.mediumDist} ${v.smallDist};

		@media ${b.medium} {
			padding: ${v.mediumDist} ${v.mediumDist};
		}

		@media ${b.large} {
			padding: ${v.xLargeDist} ${v.largeDist};
		}

		.btn__container-light {
			margin-bottom: ${v.largeDist};
		}

		.project-name {
			text-align: center;
			margin-bottom: ${v.mediumDist};
		}

		.img__container {
			margin-bottom: ${v.mediumDist};
		}

		.desc__container {
			margin-bottom: ${v.mediumDist};
		}

		.stack {
			display: flex;
			flex-wrap: wrap;
			gap: 2rem;
			margin-bottom: ${v.mediumDist};

			li {
				background: ${({ theme }) => theme.primary2};
				padding: 0.5rem 1rem;
				border-radius: 25px;
				color: ${({ theme }) => theme.textInvert};
			}
		}

		.btn__container {
			display: flex;
			flex-direction: column;
			gap: ${v.smallDist};

			@media ${b.medium} {
				flex-direction: row;
			}
			button {
				padding: 0;
				a {
					display: block;
					padding: ${v.smallDist} ${v.smallDist};
				}
			}
		}
	}
`;
